import React from "react";
import CertificateGroupingList from "../../features/CertificateGroupingList/CertificateGroupingList";
import "./CertificateGrouping.scss";

const CertificateGrouping = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingList />
    </div>
  );
};

export default CertificateGrouping;
